import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import MarketingLayout from '@/components/marketing/MarketingLayout';
import { ArrowRight } from '@/components/icons';

const STEPS = [
  { img: '/assets/klaro/icons/ddt-ocr.png', title: '1. Carica il DDT', desc: "Scatta una foto del documento di trasporto o carica un PDF. L'AI di Klaro (GPT Vision) legge ingredienti, quantità, lotti fornitore e scadenze, anche su carta stampata male." },
  { img: '/assets/klaro/icons/warehouse.png', title: '2. Lotti in magazzino', desc: 'Ogni riga letta diventa un lotto tracciato, associato al fornitore giusto. Puoi correggere qualsiasi campo prima di confermare.' },
  { img: '/assets/klaro/icons/recipes.png', title: '3. Ricetta e batch produzione', desc: 'Componi le ricette una volta sola. Al momento della produzione, Klaro scala automaticamente le quantità e genera il lotto di semilavorato o prodotto finito.' },
  { img: '/assets/klaro/icons/labels.png', title: '4. Etichette conformi', desc: 'Template drag & drop, ingredienti in ordine di peso e allergeni in grassetto secondo Reg. UE 1169/2011. Stampa PDF o su etichettatrice.' },
  { img: '/assets/klaro/icons/expiry.png', title: '5. Scadenzario in tempo reale', desc: 'Dashboard con badge OK / IN SCADENZA / SCADUTO. Filtri rapidi per lotti, semilavorati, prodotti finiti.' },
  { img: '/assets/klaro/icons/checklist-audit.png', title: '6. Registro HACCP', desc: 'Ogni azione è tracciata: chi ha registrato cosa, quando. Esporta il registro in un click quando arriva l\'ispezione.' },
];

export default function HowItWorksPage() {
  return (
    <MarketingLayout>
      <section className="mx-auto max-w-4xl px-4 sm:px-6 pt-14 sm:pt-20 pb-8 text-center">
        <p className="text-xs uppercase tracking-wide font-semibold text-[#2563EB]">Come funziona</p>
        <h1 className="mt-3 font-heading text-4xl sm:text-5xl font-semibold text-[#0A1737] leading-tight">Dal DDT all'etichetta in un flusso solo.</h1>
        <p className="mt-4 text-lg text-slate-600 max-w-2xl mx-auto">Klaro sostituisce sei attività manuali con un unico processo digitale. Ecco cosa succede quando un DDT entra in laboratorio.</p>
      </section>
      <section className="mx-auto max-w-4xl px-4 sm:px-6 py-8 sm:py-12">
        <div className="space-y-5">
          {STEPS.map((s) => (
            <div key={s.title} className="flex flex-col sm:flex-row gap-5 rounded-2xl border border-slate-200 bg-white p-6 sm:p-7 hover:border-blue-300 transition-colors" data-testid={`step-card-${s.title.split('.')[0]}`}>
              <span className="inline-flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-xl bg-slate-50">
                <img src={s.img} alt="" aria-hidden="true" className="h-12 w-12 object-contain" loading="lazy" />
              </span>
              <div>
                <h2 className="font-heading text-xl sm:text-2xl font-semibold text-[#0A1737]">{s.title}</h2>
                <p className="mt-2 text-slate-600">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
      <section className="mx-auto max-w-4xl px-4 sm:px-6 pb-16 text-center">
        <div className="rounded-2xl bg-slate-50 border border-slate-200 p-8">
          <h2 className="font-heading text-2xl sm:text-3xl font-semibold text-[#0A1737]">Vuoi vederlo sul tuo laboratorio?</h2>
          <p className="mt-2 text-slate-600">Attiviamo la tua azienda entro poche ore. Nessuna installazione, funziona da tablet o pc.</p>
          <div className="mt-5 flex flex-col sm:flex-row gap-3 justify-center">
            <Button asChild variant="success" size="lg"><Link to="/register">Registra la tua azienda<ArrowRight className="w-4 h-4 ml-1" /></Link></Button>
            <Button asChild variant="outline" size="lg"><Link to="/prezzi">Vedi i piani</Link></Button>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
